import { useEffect, useState } from "react";
import TodayIcon from "@mui/icons-material/Today";
import edit from "../../assets/orders/editorder.svg";
import schedule from "../../assets/orders/clock.svg";
import prescription from "../../assets/tasks/Noteform.svg";
import addicon from "../../assets/orders/carbon_add.svg";
import ArticleIcon from "@mui/icons-material/Article";
import { Backdrop, CircularProgress, Switch } from "@mui/material";
import NavButtons from "../nav/navbuttons";
import EditPopup from "../popups/editpopup";
import AddNotesPopup from "../popups/addnotes";
import NewRxPopup from "../popups/newrx";
import api from "../../api/api";
import LabsNavButtons from "../nav/labsbuttons";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ToastMessage from "../../utils/mui/righttoptoast";
import { setSearchResults } from "../../reduxtoolkit/orders/universalsearch";
import AddNoteData from "../../assets/tasks/NoteData.svg";
import Schedularpopup from "../popups/schedular";
import calender from "../../../src/assets/orders/calender.svg";
import {
  updatelov2Value,
  updatelovValue,
  updateTov2Value,
  updateTovValue,
} from "../../reduxtoolkit/dump";
import {
  collapseIcon,
  expandIcon,
  notesIcon,
  pendingIcon,
  penIcon,
  prescriptionIcon,
  RXIcon,
  scheduledIcon,
  todayIcon,
} from "./svg";
import { COMPLETEDIcon, CROSSIcon } from "../../landingscreen/modals/svgs";
import dayjs from "dayjs";
import OrderCards, { SearchSuggestions } from "../OrderCards";
import { getPracticeId } from "../../config/practice";

const LabsTab = ({
  data,
  appointmentId,
  setShowOrders,
  selectedSuggestionList,
  getordersData,
  referals,
  startDate,
  suggestionData,
  fetchsuggestions,
  selectedCard,
  SetSelectedCard,
}) => {
  const [isActive, setIsActive] = useState(false);
  const practiseid = getPracticeId();
  const [activeButton, setActiveButton] = useState(3);
  const [alertmessage, setAlertMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [open, setOpen] = useState(false);
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState("t");
  // const [selectedSuggestionList,setSelectedSuggestionList]=useState([])
  const [isAddnotesPopup, setAddNotesPopup] = useState(false);
  // const [suggestionData,setSuggestionsData]=useState([])
  const [loading, setLoading] = useState(false);
  // const [getordersData,setGetOrdersData]=useState([])
  const dispatch = useDispatch();
  const [isnewRxpopup, setNewRxPopup] = useState(false);
  // const [selectedCard,SetSelectedCard]=useState('f');
  const [isSchedularpopup, setIsSchedularPopUp] = useState(false);
const params = useParams();

const id = params.id || appointmentId;
const dt = params.dt || startDate;
console.log("---- Orders Debug ----");


console.log("URL param dt:", params.dt);
console.log("Prop startDate:", startDate);
console.log("Final dt used:", dt);
console.log("----------------------");
  const [expandedCards, setExpandedCards] = useState({
    today: false,
    scheduled: false,
    prescriptions: false,
    notes: false,
  });

  const navigate = useNavigate();
  const [selectedButtons, setSelectedButtons] = useState([]);
  // const [referals,setReferals]=useState([]);
  const lovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "lov")?.value
  );
  const userConfig = useSelector((state) => state.userconfig);
  const tovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "tov")?.value
  );
  const lov2Value = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "lov2")?.value
  );
  const tov2Value = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "tov2")?.value
  );

  const todayItems = [
    ...(selectedSuggestionList?.filter((d) => d.schedule === "f") ?? []),
    ...(referals ?? []),
  ];

  // Which statuses count as inactive
  const completedOrCancelled = ["COMPLETED", "CANCELLEDTASK"];

  // Are ALL items inactive?
  const allInactive =
    todayItems.length > 0 &&
    todayItems.every((item) =>
      completedOrCancelled.includes(String(item?.status).toUpperCase())
    );

  // Pending = not completed/cancelled
  const pendingItems = todayItems.filter(
    (item) => !completedOrCancelled.includes(String(item?.status).toUpperCase())&&item.context!== "Tov"
  );

  // Decide the badge number
  const badgeCount = allInactive ? todayItems.length : pendingItems.length;

  // Scheduled items logic
  const scheduledItems =
    selectedSuggestionList?.filter((d) => d.schedule === "t") ?? [];
  const scheduledCompletedOrCancelled = scheduledItems.every((item) =>
    completedOrCancelled.includes(String(item?.status).toUpperCase())
  );
  const scheduledPendingItems = scheduledItems.filter(
    (item) => !completedOrCancelled.includes(String(item?.status).toUpperCase())
  );
  const scheduledBadgeCount =
    scheduledCompletedOrCancelled && scheduledItems.length > 0
      ? scheduledItems.length
      : scheduledPendingItems.length;

  // Prescriptions items logic
  const prescriptionItems = getordersData?.rx_recipe ?? [];
  const prescriptionBadgeCount = prescriptionItems.length; // Prescriptions don't have status, so show all

  // Notes items logic
  const notesItems = getordersData?.notes ?? [];
  const notesBadgeCount = notesItems.length; // Notes don't have status, so show all

  const toggleSelection = (id) => {
    setSelectedButtons((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((buttonId) => buttonId !== id)
        : [...prevSelected, id]
    );
  };

  const toggleCardExpansion = (cardName) => {
    setExpandedCards((prev) => ({
      ...prev,
      [cardName]: !prev[cardName],
    }));
  };
  const searchResults = useSelector(
    (state) => state.universalsearcher.searchResults
  );

  const handlealert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  }
  const editalert = (text, sev) => {
    setIsEditPopupOpen(false);
    setSeverity(sev);
    setAlertMessage(text);
    setOpen(true);
    fetchsuggestions();
  };
useEffect(()=>{
    fetchsuggestions()
},[dt])
  const selectsuggestion = async (order) => {
    setLoading(true);
    
    console.log("Selected order:", order,order.content);
    try {
      const createResponse = await api.post(
        `/v1/${practiseid}/patient/${data.patientid}/orders/create`,
        {
          department_id: 1,
          patient_name: `${data.firstname || ""} ${data.lastname || ""}`.trim(),
          tov: tovValue, // purpose
          lov: lovValue,
          diagnosis: "",
          ordertype: order.context=='diagnosis'?'Diagnostic Tests':order.context, // tabs
          ordername:order.content, // buttons
          schedule: selectedCard, // t/f-schedule
          // provider: data.linked_provider,
          provider: `${userConfig?.firstname || ""} ${userConfig?.lastname || ""}`,
          status: "CREATED",
          confirm_status: "E", // C/E
          // orderdate:  userdata.created_at?new Date(userdata.created_at).toISOString().split('T')[0]: "Invalid date",
      orderdate: dayjs(dt).isValid()
  ? dayjs(dt).format("YYYY-MM-DD")
  : dayjs().format("YYYY-MM-DD"),
          encounterid: 0,
        }
      );
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      dispatch(setSearchResults([]));
      fetchsuggestions();
    }
  };

  return (
    <>
      <div className="bmor bmor-pick-body">
      <LabsNavButtons
        selectedCard={selectedCard}
        userdata={data}
        selectedSuggestionList={selectedSuggestionList}
        fetchsuggestions={fetchsuggestions}
        appointmentId={appointmentId}
        startDate={startDate}
        dt={dt}
       data={[
    ...suggestionData,
    ...["STREP TEST", "FLU TEST", "COVID TEST"]
      .filter(
        (test) =>
          !suggestionData.some(
            (item) => item.content?.toLowerCase() === test.toLowerCase()
          )
      )
      .map((test) => ({ content: test })),
  ]}
        loading={loading}
        getordersData={getordersData}
      />
      <SearchSuggestions results={searchResults} onPick={selectsuggestion} />
      </div>


      <OrderCards
        selectedSuggestionList={selectedSuggestionList}
        referals={referals}
        getordersData={getordersData}
        selectedCard={selectedCard}
        SetSelectedCard={SetSelectedCard}
        onEdit={(which) => {
          setSelectedEdit(which);
          setIsEditPopupOpen(true);
        }}
        onAddRx={() => setNewRxPopup(true)}
        onAddNote={() => setAddNotesPopup(true)}
        onScheduleProcedure={() => setIsSchedularPopUp(true)}
      />
      {/* <div className="w-full flex justify-end gap-4 sm:gap-4 mt-4">

                    <button
                    onClick={()=>handleClose()}
                        className="rounded w-[100px] bg-white cursor-pointer text-black border-[1.5px] border-gray-200 py-1 px-3 transition duration-300 ease-in-out  hover:bg-gray-800">
                        Close
                    </button>

                    <button
onClick={()=>handleSave()}
                        className="rounded w-[100px] py-1 px-3 bg-[#1E2A4A] text-white  transition duration-300 ease-in-out hover:bg-gray-800">
                        Save
                    </button>
                </div> */}
      <Schedularpopup
        isOpen={isSchedularpopup}
        onClose={setIsSchedularPopUp}
        data={data}
      />
      <EditPopup
        userdata={data}
        fetchsuggestions={fetchsuggestions}
        data={data}
        selectedEdit={selectedEdit}
        editalert={editalert}
        isOpen={isEditPopupOpen}
        onClose={() => setIsEditPopupOpen(false)}
        getordersData={getordersData}
dt={dt}
        
      />
      <AddNotesPopup
        fetchsuggestions={fetchsuggestions}
        userdata={data}
        isOpen={isAddnotesPopup}
        onClose={() => setAddNotesPopup(false)}
        dt={dt}
      />
      <NewRxPopup
        fetchsuggestions={fetchsuggestions}
        userdata={data}
        isOpen={isnewRxpopup}
        onClose={() => setNewRxPopup(false)}
            dt={dt}
      />
      <Backdrop
        sx={{
          color: "secondary.main", // Sets the CircularProgress color to secondary
          backgroundColor: "rgba(255, 255, 255, 0.5)", // Semi-transparent white background
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={loading}
      >
        <CircularProgress color="secondary" />
      </Backdrop>

      <ToastMessage
        message={alertmessage}
        severity={severity}
        open={open}
        handleClose={handlealert}
      />
    </>
  );
};
export default LabsTab;
